import { render, staticRenderFns } from "./KanbanGroupSelector.vue?vue&type=template&id=ef826300&scoped=true"
import script from "./KanbanGroupSelector.vue?vue&type=script&lang=js"
export * from "./KanbanGroupSelector.vue?vue&type=script&lang=js"
import style0 from "./KanbanGroupSelector.vue?vue&type=style&index=0&id=ef826300&prod&lang=scss&scoped=true"
import style1 from "./KanbanGroupSelector.vue?vue&type=style&index=1&id=ef826300&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef826300",
  null
  
)

export default component.exports